import { AnimatePresence, motion } from 'motion/react';
import { useUI } from '../state/ui.js';
import { Icon } from './Icon.js';

/** Renders transient toast notifications from the UI store. */
export function Toaster() {
  const { toasts, dismissToast } = useUI();
  return (
    <div className="toaster" role="status" aria-live="polite">
      <AnimatePresence initial={false}>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            className={`toast toast-${toast.tone}`}
            initial={{ opacity: 0, y: 16, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.95 }}
            transition={{ type: 'spring', bounce: 0.25, duration: 0.35 }}
            layout
          >
            {toast.tone === 'error' && <Icon name="alert" size={18} />}
            {toast.tone === 'success' && <Icon name="check" size={18} />}
            <span>{toast.message}</span>
            <button
              type="button"
              className="toast-close"
              aria-label="Close"
              onClick={() => dismissToast(toast.id)}
            >
              <Icon name="close" size={16} />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
